module.exports = __webpack_public_path__ + "img/download.91f1f055.svg";